export default __webpack_public_path__ + "static/media/shop-slide-img-01.f55bf165.png";